import { render, staticRenderFns } from "./childrenage.vue?vue&type=template&id=6d9e7ab4&"
import script from "./childrenage.vue?vue&type=script&lang=js&"
export * from "./childrenage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d9e7ab4')) {
      api.createRecord('6d9e7ab4', component.options)
    } else {
      api.reload('6d9e7ab4', component.options)
    }
    module.hot.accept("./childrenage.vue?vue&type=template&id=6d9e7ab4&", function () {
      api.rerender('6d9e7ab4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2egdCK8MzrRIe/JS/comp/childrenage.vue"
export default component.exports